/* ----------------- Globals --------------- */
import { ScrollView } from "react-native";

/* ----------------- Helpers --------------- */
import { isWeb } from "../../helpers/platform";

import { useAppTheme } from "@hooks/useAppTheme";
import TooltipWrapper from "@memorang/ui/src/components/TooltipWrapper";
import { useDevice } from "@memorang/ui/src/useDevice";
import { Chip } from "react-native-paper";
/* ----------------- Components --------------- */
import type { QuickActionsChipType } from "./types";

/* ----------------- Types --------------- */

type Props = {
	quickActionsChips: QuickActionsChipType[];
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
};
export const QuickActionChips = ({
	quickActionsChips,
	handleQuickActionPress,
}: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();
	return (
		<ScrollView
			horizontal
			showsHorizontalScrollIndicator={false}
			contentContainerStyle={{
				gap: 8,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
		>
			{quickActionsChips?.map((chip) => {
				const Content = () => (
					<Chip
						icon={chip.icon}
						mode={chip.selected ? "flat" : "outlined"}
						compact
						textStyle={{ fontSize: theme.fonts.labelLarge.fontSize }}
						selected={chip.selected}
						style={{
							// maxHeight: 32,
							alignItems: "center",
						}}
						onPress={() => {
							handleQuickActionPress(chip.type);
						}}
					>
						{chip.label}
					</Chip>
				);
				return isWeb ? (
					<TooltipWrapper title={chip.tooltip} key={chip.label}>
						<Content />
					</TooltipWrapper>
				) : (
					<Content key={chip.label} />
				);
			})}
		</ScrollView>
	);
};
